import React from 'react';

interface LogoProps {
  variant?: 'light' | 'dark';
}

export default function Logo({ variant = 'dark' }: LogoProps) {
  const borderColor = variant === 'light' ? 'border-brand-light' : 'border-emerald-600';
  const textColor = variant === 'light' ? 'text-white' : 'text-gray-900';
  const shieldColor = variant === 'light' ? 'text-brand-light' : 'text-emerald-600';

  return (
    <div className="flex items-center space-x-2">
      <div className="relative">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`w-8 h-8 ${shieldColor}`}
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
        </svg>
        <span className={`absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/2 font-bold text-sm ${shieldColor}`}>
          pq
        </span>
      </div>
      <span className={`text-xl font-bold ${textColor}`}>PQstart</span>
    </div>
  );
}